import { render, staticRenderFns } from "./ChallengerDetailAdviser.vue?vue&type=template&id=765e64f3&scoped=true"
import script from "./ChallengerDetailAdviser.vue?vue&type=script&lang=ts"
export * from "./ChallengerDetailAdviser.vue?vue&type=script&lang=ts"
import style0 from "./ChallengerDetailAdviser.vue?vue&type=style&index=0&id=765e64f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "765e64f3",
  null
  
)

export default component.exports